'use client'
import { Icon } from '@/icons'
import cn from 'classnames'
import { FunctionComponent, PropsWithChildren } from 'react'
import styles from './Popup.module.scss'

interface PopupProps {
  onClose?: () => void
  className?: string
  withoutClose?: boolean
  withoutCloseBg?: boolean
}
export const Popup: FunctionComponent<PropsWithChildren<PopupProps>> = ({
  onClose = () => {},
  className,
  children,
  withoutClose = false,
  withoutCloseBg = false,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <div
        className={styles.bg}
        onClick={!withoutCloseBg ? onClose : null}
        data-testid="popupBgClose"
      ></div>
      <div className={styles.content}>
        <div className={styles.popup}>{children}</div>
        {!withoutClose ? (
          <button
            className={styles.close}
            onClick={onClose}
            data-testid="popupCloseButton"
          >
            <Icon name="close" className={styles.iconClose} />
          </button>
        ) : null}
      </div>
    </div>
  )
}
